import { compose } from 'recompose';

import user from 'js/lib/user';
import waitForGraphQL from 'js/lib/waitForGraphQL';

import FinAidQueryByUser from 'bundles/my-purchases-graphql/components/tabs/enhancers/FinAidQueryByUser.graphql';

import type {
  FinAidQueryByUserQuery,
  FinAidQueryByUserQueryVariables,
} from '../tabs/enhancers/__generated__/FinAidQueryByUser';

export type WithHasFinancialAidApplicationProps = {
  hasFinancialAidApplications: boolean;
};

export default compose(
  waitForGraphQL<{}, FinAidQueryByUserQuery, FinAidQueryByUserQueryVariables, WithHasFinancialAidApplicationProps>(
    FinAidQueryByUser,
    {
      props: ({ data }) => ({
        hasFinancialAidApplications: Boolean(data?.FinancialAidApplication?.queryByUser?.elements?.length),
      }),
      options: () => ({
        variables: {
          userId: user.get().id.toString(),
          limit: 1,
        },
        errorPolicy: 'all',
        context: { clientName: 'gatewayGql' },
      }),
    }
  )
);
